import { transform } from "ol/proj";

import OlStyle from "ol/style/Style";
import OlStroke from "ol/style/Stroke";
import OlCircle from "ol/style/Circle";
import OlFill from "ol/style/Fill";
import OlIcon from "ol/style/Icon";
import OlRegularShape from "ol/style/RegularShape";
import OlText from "ol/style/Text";

import OlGeomMultiPoint from "ol/geom/MultiPoint";
import OlGeomPoint from "ol/geom/Point";
import OlGeomPolygon from "ol/geom/Polygon";
import OlGeomLineString from "ol/geom/LineString";
import { toStringHDMS } from 'ol/coordinate';
import { createStringXY } from 'ol/coordinate';

import { formatArea, formatLength } from "@/lib/olHelpers";
import { getArea } from "ol/sphere";
import RegularShape from "ol/style/RegularShape";

import StripesPattern from "@/images/stripes_pattern.png"
import { ColorLike } from "ol/colorlike";

export {
  drawStyle,
  measurementsStyle,
  measuringStyle,
  recordStyle,
  workingRecordStyle,
  selectedRecordStyle,
  hoveringRecordStyle,
  geoLocateStyle,
  objectAnalysisRecordStyle,
  fishnetStyle,
  imageInfoStyle,
  selectedImageInfoStyle,
  photo360Style,
  lokacijeStyle,
  highlightedBuildingStyle,
  qcHighlightedRecordStyle,
  qcRegularRecordStyle
};

const STRIPES_IMG = new Image(16, 16);
STRIPES_IMG.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAALUlEQVQ4jWNgIB84MDAwvCJXsy0DA8NLBgYGp1HNo5pHNVNJMwMDJEs6kKsZAJymFgVl4RVWAAAAAElFTkSuQmCC";

const createStripesPattern = () => {

  const canvas = document.createElement('canvas');
  canvas.width = 16; // Set the width of the pattern canvas
  canvas.height = 16; // Set the height of the pattern canvas
  const context = canvas.getContext('2d');

  return context?.createPattern(STRIPES_IMG, "repeat");
}

const recordStyle = () => {
  let style = new OlStyle({
    image: new OlCircle({
      radius: 7,
      stroke: new OlStroke({
        color: "rgba(255, 255, 255, 0.79)"
      }),
      fill: new OlFill({
        color: "rgba(26, 114, 158, 0.79)"
      })
    }),
    fill: new OlFill({
      color: "rgba(184, 184, 184, 0.4)"
    }),
    stroke: new OlStroke({
      color: "#f03b20",
      width: 3.25
    })
  });
  return style;
};


const workingRecordStyle = () => {
  return new OlStyle({
    image: new OlCircle({
      radius: 15,
      stroke: new OlStroke({
        color: "#FF00FF",
        width: 3.25
      })
    }),
    stroke: new OlStroke({
      color: "#FF00FF",
      width: 3.25
    }),
    fill: new OlFill({
      color: "rgba(255, 0, 255, 0.2)"
    })
  });
}

const selectedRecordStyle = (f: any) => {
  const id = f.getId();
  const iid = id ? (typeof id === "string" ? parseInt(id, 10) : id) : 0
  
  const isPoint = f.values_.geometry.getType() == "Point"
  const label = isPoint ? "" : id ? (iid % 1000000).toString() : '?';
  return new OlStyle({
    image: new OlCircle({
      radius: 20,
      stroke: new OlStroke({
        color: "#00FF00",
        width: 3.25
      })
    }),
    stroke: new OlStroke({
      color: "#00FF00",
      width: 3.25
    }),
    text: new OlText({
      text: label,
      overflow: true,
      fill: new OlFill({ color: "#000" }),
      stroke: new OlStroke({
        color: "#fff"
        , width: 8
      }),
    })
  });
};

const lokacijeStyle = (f: any) => {
  const id = f.getId();
  const kb = f.get("kb");
  const statusId = f.get("lokacija_status_id") as number;
  const hasObveznik = f.get("has_obveznik") as string;

  let fillColor = "#4D7530";
  let textColor = "#fff"
  let outlineColor = "#fff"
  let strokeColor = "#00FF00";

  switch (statusId) {
    case 1:
      fillColor = "#00008B";
      break;
    case 2:
      fillColor = "#9C1111";
      break;
    case 3:
      fillColor = "#307565"
      break;
    case 4:
      fillColor = "#93cfa3";
      textColor = "#000";
      break;
  }

  if (hasObveznik === "NE") {
    strokeColor = "#FF0000";
  }
  
  // const iid = id ? (typeof id === "string" ? parseInt(id, 10) : id) : 0
  const label = kb || '?';
 
  return new OlStyle({
    image: new OlCircle({
      fill: new OlFill({ color: fillColor }),
      stroke: new OlStroke({
        color: strokeColor
        , width: 4
      }),
      radius: 10
    }),
    text: new OlText({
      text: label,
      overflow: true,
      fill: new OlFill({ color: textColor })
    })
  });
};

const hoveringRecordStyle = (f: any) => {
  const id = f.getId();
  const iid = id ? (typeof id === "string" ? parseInt(id, 10) : id) : 0
  const label = id ? (iid % 1000000).toString() : '?';
  return new OlStyle({
    image: new OlCircle({
      radius: 15,
      stroke: new OlStroke({
        color: "#feb24c",
        width: 3.25
      })
    }),
    stroke: new OlStroke({
      color: "#feb24c",
      width: 3.25
    }),
    text: new OlText({
      text: label,
      overflow: true,
      fill: new OlFill({ color: "#000" }),
      stroke: new OlStroke({
        color: "#fff"
        , width: 8
      }),
    })
  });
};

const highlightedBuildingStyle = (f: any) => {
  return new OlStyle({
    image: new OlCircle({
      radius: 15,
      stroke: new OlStroke({
        color: "#feb24c",
        width: 3.25
      })
    }),
    stroke: new OlStroke({
      color: "#feb24c",
      width: 3.25
    })
  });
};


const drawStyle = new OlStyle({
  image: new OlCircle({
    radius: 7,
    stroke: new OlStroke({
      color: "rgba(255, 255, 255, 0.79)"
    }),
    fill: new OlFill({
      color: "rgba(26, 114, 158, 0.79)"
    })
  }),
  fill: new OlFill({
    color: "rgba(255,255,255,0.4)"
  }),
  stroke: new OlStroke({
    color: "#3399CC",
    width: 3.25
  })
});

const measuringStyle = new OlStyle({
  fill: new OlFill({
    color: 'rgba(255, 255, 255, 0.2)',
  }),
  stroke: new OlStroke({
    color: 'rgba(0, 0, 0, 0.5)',
    lineDash: [10, 10],
    width: 4,
  }),
  image: new OlCircle({
    radius: 5,
    stroke: new OlStroke({
      color: 'rgba(0, 0, 0, 0.5)',
      width: 4
    }),
    fill: new OlFill({
      color: 'rgba(255, 255, 255, 0.2)',
    }),
  })
});

// @Piero
// not sure what f is at the moment (maybe layer)
const measurementsStyle = (f: any) => {
  const geom = f.getGeometry();

  console.log(f);

  var output;
  var tooltipCoord;

  if (geom instanceof OlGeomPolygon) {
    output = formatArea(geom);
    //tooltipCoord = geom.getInteriorPoint().getCoordinates();
    tooltipCoord = geom.getCoordinates()[0];
  } else if (geom instanceof OlGeomLineString) {
    output = formatLength(geom);
    tooltipCoord = geom.getCoordinates()[0];
  } else if (geom instanceof OlGeomPoint) {
    let htrs_array = transform(geom.getCoordinates(), "EPSG:3857", "EPSG:3765");
    output = "X: " + htrs_array[0].toFixed(0) + ", Y:" + htrs_array[1].toFixed(0);
    tooltipCoord = geom;
  }
  let style = [
    new OlStyle({
      image: new OlCircle({
        radius: 5,
        stroke: new OlStroke({
          color: 'rgba(0, 0, 0, 0.8)',
          width: 4
        }),
        fill: new OlFill({
          color: "rgba(255, 255, 255, 0.2)"
        })
      })
    }),
    new OlStyle({
      fill: new OlFill({
        color: "rgba(255, 255, 255, 0.5)"
      }),
      stroke: new OlStroke({
        color: 'rgba(0, 0, 0, 0.8)',
        lineDash: [10, 10],
        width: 4,
      })
    }),
    new OlStyle({
      text: new OlText({
        font: "12px sans serif",
        fill: new OlFill({ color: "#000" }),
        stroke: new OlStroke({
          color: "#fff"
          , width: 8
        }),
        text: output,
        textBaseline: "center",
        offsetY: -12
      })
    })
    // ,
    // new OlStyle({
    //   image: new OlCircle({
    //     radius: 3,
    //     stroke: new OlStroke({
    //       color: "#232f34"
    //     }),
    //     fill: new OlFill({
    //       color: "rgba(255, 255, 255, 0.2)"
    //     })
    //   }),
    //   geometry: function (feature) {
    //     // return the coordinates of the first ring of the polygon
    //     const geom = feature.getGeometry();
    //     const type = geom.getType();
    //     var coordinates = geom.getCoordinates
    //       ? type === "Polygon"
    //         ? geom.getCoordinates()[0]
    //         : geom.getCoordinates()
    //       : null;
    //     return coordinates ? new OlGeomMultiPoint(coordinates) : null;
    //   }
    // })
  ];
  //@ts-ignore
  if (f.__callback) {
    //@ts-ignore
    f.__callback(getArea(geom));
  }
  return style;
};

const geoLocateStyle = new OlStyle({
  image: new OlCircle({
    radius: 6,
    fill: new OlFill({
      color: '#3399CC',
    }),
    stroke: new OlStroke({
      color: '#fff',
      width: 2,
    })
  })
});

const objectAnalysisRecordStyle = (f: any) => {
  const pregledano = f.get("pregledano");
  const stroke = f.get("stroke");
  const stroke_width = f.get("stroke_width");
  const stripes = f.get("_stripes");
  const fill = f.get("fill");
  const tip = f.get("objekt_tip_id");

  const colorPregledano = "#d9ef8b";

  const colorTip1 = "#d73027";
  const colorTip2 = "#756bb1";
  const colorTip9 = "#feb24c";

  let style = new OlStyle({
    fill: new OlFill({
      color: fill || "rgba(184, 184, 184, 0.4)",

    }),
    stroke: new OlStroke({
      color: stroke ? stroke :
        pregledano ? colorPregledano : 
        tip === 2 ? colorTip2 :
        tip === 9 ? colorTip9 : colorTip1,
      width: stroke_width || 3.25
    })
  });

  if (stripes) {
    const pattern = createStripesPattern();

    const stripesStyle = new OlStyle({
      fill: new OlFill({
        color: pattern as ColorLike
      })
    })
    return [style, stripesStyle];
  } else {
    return style;
  }
};

const qcRegularRecordStyle = (f: any) => {
  const stroke = f.get("stroke");
  const stroke_width = f.get("stroke_width");
  const stripes = f.get("_stripes");
  const fill = f.get("fill");

  let style = new OlStyle({
    fill: new OlFill({
      color: fill || "rgba(184, 184, 184, 0.4)",

    }),
    stroke: new OlStroke({
      color: stroke ? stroke :
        "#d9ef8b",
      width: stroke_width || 3.25
    })
  });

  if (stripes) {
    const pattern = createStripesPattern();

    const stripesStyle = new OlStyle({
      fill: new OlFill({
        color: pattern as ColorLike
      })
    })
    return [style, stripesStyle];
  } else {
    return style;
  }

}

const qcHighlightedRecordStyle = (f: any) => {
  let style = new OlStyle({
    image: new OlCircle({
      radius: 7,
      stroke: new OlStroke({
        color: "rgba(255, 255, 255, 0.79)"
      }),
      fill: new OlFill({
        color: "rgba(26, 114, 158, 0.79)"
      })
    }),
    fill: new OlFill({
      color: "rgba(184, 184, 184, 0.4)"
    }),
    stroke: f.get('qc_check') ? new OlStroke({
      color: "rgb(26, 114, 158)",
      width: 3.75
    }) : new OlStroke({
      color: "#f03b20",
      width: 3.25
    }) 
  });
  return style;
};


const fishnetStyle = (f: any) => {
  const sifra = f.get("sifra");
  const label = sifra ? sifra.toString() : "?";

  let style = new OlStyle({
    stroke: new OlStroke({
      color: "#feb24c",
      width: 3.25
    }),
    text: new OlText({
      text: label,
      overflow: true,
      fill: new OlFill({ color: "#000" }),
      stroke: new OlStroke({
        color: "#feb24c"
        , width: 8
      }),
    })
  });
  return style;
};

const R_HEAD = 8;
const R_SHAFT = 5;
const R_BUFFER = 10;
const ARROW_COLOR = "rgba(255, 0, 255, 0.8)";
const SELECTED_ARROW_COLOR = "#00FF00";

const shaftStyle = (deg: number, col?: string) => new OlRegularShape({
  points: 2,
  radius: R_SHAFT,
  stroke: new OlStroke({
    width: 4,
    color: "#FFF"
  }),
  fill: new OlFill({
    color: col ? col : ARROW_COLOR
  }),
  rotation: deg,
  rotateWithView: true,
});

const headStyle = (deg: number, col?: string) => new OlRegularShape({
  points: 3,
  radius: R_HEAD,
  stroke: new OlStroke({
    width: 2,
    color: "#FFF"
  }),
  fill: new OlFill({
    color: col ? col : ARROW_COLOR,
  }),
  displacement: [0, R_HEAD / 2 + R_SHAFT],
  rotation: deg,
  rotateWithView: true,
});

const invisibleBuffer = (d: number, deg: number) => (
  new OlStyle({
    image: new OlCircle({
      fill: new OlFill({ color: 'rgba(0,0,0,0.0)' }),
      stroke: new OlStroke({ width: 2, color: 'rgba(0,0,0,0.0)' }),
      radius: R_BUFFER,
      displacement: [0, d],
      rotation: deg,
      rotateWithView: true,
    })
  })
)

const imageInfoStyle = (f: any) => {
  const geom = f.getGeometry();
  const [x, y, m] = geom.flatCoordinates;

  let rotation = m;
  if (m < 0) {
    rotation = 360 + m;
  }
  rotation = (rotation / 180) * Math.PI;

  const head = new OlStyle({
    image: headStyle(rotation)
  })
  const headBuffer = invisibleBuffer(R_HEAD / 2 + R_SHAFT, rotation)
  const shaft = new OlStyle({
    image: shaftStyle(rotation)
  })
  const shaftBuffer = invisibleBuffer(0, 0);
  return [head, shaft, shaftBuffer, headBuffer];
};

const selectedImageInfoStyle = (f: any) => {
  const geom = f.getGeometry();
  const [x, y, m] = geom.flatCoordinates;

  let rotation = m;
  if (m < 0) {
    rotation = 360 + m;
  }
  rotation = (rotation / 180) * Math.PI;

  const head = new OlStyle({
    image: headStyle(rotation, SELECTED_ARROW_COLOR)
  })
  const shaft = new OlStyle({
    image: shaftStyle(rotation, SELECTED_ARROW_COLOR)
  })
  return [head, shaft];
};

const photo360Style = () => {

  const color1 = "#0d47a1";
  const color2 = "#FFF";

  const outer = new OlStyle({
    image: new OlCircle({
      radius: 5,
      scale: [1.5, 1],
      fill: new OlFill({
        color: color2,
      })
    })
  });

  const inner = new OlStyle({
    image: new OlCircle({
      radius: 3,
      stroke: new OlStroke({
        color: color1,
        width: 2
      }),
      fill: new OlFill({ color: color2 })
    })
  })

  return [outer, inner];
}
